<template>
  <div>
    <InfoDetails :data="articleDetails" :isTranslated="isTranslated">
      <FileEntry :url="fileUrl" />
      <!-- AI -->
      <template v-slot:overview>
        <div class="overview" v-if="!!overview">
          <AIOverview :overviewTitle="overviewTitle" defaultShowedOverview :isTranslated="isTranslated">
            <template v-slot:content>
              <div style="white-space: pre-line">{{ overview }}</div>
            </template>
          </AIOverview>
        </div>
      </template>
    </InfoDetails>
    <Disclaimer />
  </div>
</template>

<script>
import InfoDetails from '@/components/common/info/InfoDetails.vue'
import FileEntry from '@/components/common/info/FileEntry.vue'
import Disclaimer from '@/components/common/Disclaimer.vue'
import AIOverview from '@/components/common/AIOverview.vue'
import { sendMsg, watchMsg } from '@/plugins/msg'

export default {
  components: { InfoDetails, FileEntry, Disclaimer, AIOverview },
  data() {
    return {
      isTranslated: this.$route.query.isTranslated === 'true',

      fileUrl: null,

      details: {}
    }
  },
  computed: {
    overviewTitle() {
      return `${this.$t('总结完成，以下是我提取的核心信息')}`
    },
    overview() {
      if (this.$route.query.hiddenAI) {
        return ''
      }

      const res = this.isTranslated ? this.articleDetails.translatedOverview : this.articleDetails.overview

      return res
    },
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    noticeId() {
      return this.$route.query.id
    },
    articleDetails() {
      const detail = this.details || JSON.parse(localStorage.getItem('announcement-detail') || '{}')

      const { title = this.$route.query.title, time = this.$route.query.time, lang } = detail

      // 发送 原文语言 给父级窗口，用来判断是否显示翻译按钮
      sendMsg({
        event: 'detailLang',
        lang
      })

      return {
        ...detail,
        title,
        time
      }
    }
  },
  created() {
    this.getPdfUrl()
  },
  mounted() {
    watchMsg(this.watchCallback)
    this.getAnnouncementDetails()
  },
  methods: {
    async getAnnouncementDetails() {
      const res = await this.$post(this.$api.rm[this.market] + '/notice/details', {
        noticeId: this.noticeId
      })

      const data = res.body ?? {}

      this.details = data
    },
    watchCallback(res) {
      if (res.event === 'newsDetailTranslate') {
        this.isTranslated = !this.isTranslated
      }
    },
    async getPdfUrl() {
      const res = await this.$post(this.$api.sdk[this.market] + '/notice/getAttachment', {
        noticeId: this.noticeId
      })

      if (res.code === '200') {
        this.fileUrl = this.getUrlByMarket(res.body.attachmentUrl)
      }
    },
    getUrlByMarket(data) {
      const urlMap = {
        hk: data?.[0],
        hs: data,
        us: data
      }
      return urlMap[this.market]
    }
  }
}
</script>

<style lang="scss" scoped>
.overview {
  margin-top: 15px;
}
</style>
